<span *ngIf="time; else minTitleRef">{{ time }}</span>
<ng-template #minTitleRef>
  <span>{{ minTitle | translate }}</span>
</ng-template>

